// Interface for raw room data from backend
export interface RawRoomData {
  id: number;
  institution_id: number;
  room_code: string;
  name: string;
  max_capacity?: number | null;
  is_handicap_accessible: boolean;
  equipment?: string | null;
  notes?: string | null;
  public_visible?: boolean | null;
  preferences?: Array<{
    id: number;
    day: string;
    start_time: string;
    end_time: string;
    status: string;
  }>;
  createdAt?: string;
  updatedAt?: string;
}

class Room {
  id: number;
  institutionId: number;
  roomCode: string;
  name: string;
  maxCapacity?: number | null;
  isHandicapAccessible: boolean;
  equipment?: string | null;
  notes?: string | null;
  publicVisible: boolean;
  preferences: Array<{
    id: number;
    day: string;
    startTime: string;
    endTime: string;
    status: string;
  }>;
  createdAt?: string;
  updatedAt?: string;

  constructor(data: RawRoomData) {
    this.id = data.id;
    this.institutionId = data.institution_id;
    this.roomCode = data.room_code;
    this.name = data.name;
    this.maxCapacity = data.max_capacity;
    this.isHandicapAccessible = data.is_handicap_accessible;
    this.equipment = data.equipment;
    this.notes = data.notes;
    this.publicVisible = data.public_visible !== false;
    this.preferences = data.preferences ? data.preferences.map(pref => ({
      id: pref.id,
      day: pref.day,
      startTime: pref.start_time,
      endTime: pref.end_time,
      status: pref.status
    })) : [];
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
  }

  toRawData(): RawRoomData {
    return {
      id: this.id,
      institution_id: this.institutionId,
      room_code: this.roomCode,
      name: this.name,
      max_capacity: this.maxCapacity,
      is_handicap_accessible: this.isHandicapAccessible,
      equipment: this.equipment,
      notes: this.notes,
      public_visible: this.publicVisible,
      preferences: this.preferences.map(pref => ({
        id: pref.id,
        day: pref.day,
        start_time: pref.startTime,
        end_time: pref.endTime,
        status: pref.status
      })),
      createdAt: this.createdAt,
      updatedAt: this.updatedAt
    };
  }

  static fromRawDataArray(rawData: RawRoomData[]): Room[] {
    return rawData.map(data => new Room(data));
  }
}

export default Room; 